import React from 'react';
import IconSearch from '../../../../../../../../svg/icons/icon-search.svg';
import inputStyles from './input.module.pcss';
import useTranslateOnScroll from '../../hooks/useTranslateOnScroll';
import { MessagePropertiesContext } from '../../../../../../contexts/messageProperties';

export const INPUT_ELEMENT_ID = 'search-app-input';

interface InputProps {
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleFocus: () => void;
  handleEsc: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  handleBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  open: boolean;
  canDisplayDropdown: boolean;
  innerWidth: number;
  maxLength: number;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    { open, canDisplayDropdown, innerWidth, maxLength, handleChange, handleFocus, handleEsc, handleBlur }: InputProps,
    inputRef
  ): React.ReactElement => {
    const [formattedMessage] = React.useContext(MessagePropertiesContext);

    useTranslateOnScroll(open, innerWidth);

    return (
      <>
        <div className={inputStyles.flex}>
          <input
            ref={inputRef}
            autoComplete="off"
            aria-label="search bar"
            className={inputStyles.input}
            id={INPUT_ELEMENT_ID}
            type="search"
            name="text"
            maxLength={maxLength}
            placeholder={formattedMessage({
              id: 'search.input.placeholder',
              fallback: 'Search for a keyword, brand or product'
            })}
            onChange={handleChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onKeyDown={handleEsc}
            data-click-inside-search
            required
          />
          <button className={inputStyles.input__submit} type="submit">
            <IconSearch className={inputStyles.input__icon} />
          </button>
        </div>
        <div className={inputStyles['input__tooltip-wrapper']}>
          <div className={canDisplayDropdown ? inputStyles.input__tooltip : inputStyles['input__tooltip--hidden']}>
            <div className={inputStyles['input__tooltip-triangle--1']} />
            <div className={inputStyles['input__tooltip-triangle--2']} />
          </div>
        </div>
      </>
    );
  }
);

export default Input;
